import SoftSelect from 'components/SoftSelect'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import { useRef, useState } from 'react'
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { selectData } from 'layouts/onboarding'

export const SplitDateField = ({
  intakeAttribute,
  options,
  label,
  placeholder,
  onChange = (e) => console.log(e),
  moveToNext,
  autoFocus,
  hiddenLabel,
  value,
  dateListTrim,
}) => {
  const [datePartsYear, setDatePartsYear] = useState(value.split('-')[0])
  const [datePartsMonth, setDatePartsMonth] = useState(value.split('-')[1])
  const [datePartsDay, setDatePartsDay] = useState(value.split('-')[2])

  const dateParts = {
    datePartsYear: datePartsYear,
    datePartsMonth: datePartsMonth,
    datePartsDay: datePartsDay,
  }

  const dateValue = ({
    datePartsYear: datePartsYear,
    datePartsMonth: datePartsMonth,
    datePartsDay: datePartsDay,
  }) => {
    return datePartsYear + '-' + datePartsMonth + '-' + datePartsDay
  }

  const handleYearChange = (e) => {
    setDatePartsYear(e.target.value)
    onChange(dateValue({ ...dateParts, datePartsYear: e.target.value }))
  }
  const handleMonthChange = (e) => {
    setDatePartsMonth(e.target.value)
    onChange(dateValue({ ...dateParts, datePartsMonth: e.target.value }))
  }
  const handleDayChange = (e) => {
    setDatePartsDay(e.target.value)
    onChange(dateValue({ ...dateParts, datePartsDay: e.target.value }))
  }
  const selectStyles = {
    '&>label': {
      fontSize: '14px',
      color: '#75787B',
      top: '-2px',
    },
    '&>label.Mui-focused': {
      fontSize: '1rem',
      color: '#2370ED',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.Mui-focused.Mui-error': {
      color: '#ea0606',
    },
    '&>label.MuiFormLabel-filled, &>label.MuiInputLabel-shrink': {
      fontSize: '1rem',
      background: '#fff',
      padding: '0 5px',
      marginLeft: '-5px',
      top: 0,
    },
    '&>label.MuiFormLabel-filled.Mui-disabled': {
      top: 0,
      background:
        'linear-gradient(to bottom, #fff 0%, #fff 50%, #e9ecef 50%, #e9ecef 100%)',
    },
    '&>div.MuiInputBase-root': {
      padding: '0!important',
      borderRadius: '4px !important',
    },
    '&>div.MuiInputBase-root.Mui-disabled': {
      backgroundColor: '#e9ecef!important',
    },
    '&>div.MuiInputBase-root.Mui-focused': {
      boxShadow: '0 0 0 1.5px #2370ED',
    },
    '&>div>.MuiInputBase-input': {
      width: '100%!important',
      padding: '0.75rem 1.75rem 0.75rem 0.75rem!important',
      display: 'flex',
    },
    '&>div>.MuiInputBase-input>.MuiListItemIcon-root': {
      minWidth: 'unset',
    },
    '&>div>.MuiInputBase-input>.MuiListItemIcon-root>img': {
      height: '20px',
      width: 'auto',
      marginRight: '8px',
    },
    '&>div>.MuiInputBase-input>.MuiListItemText-root>span': {
      fontSize: '14px',
    },
    '&>div.MuiInputBase-root>svg': {
      display: 'block',
      height: '1.5em',
      width: '1.5em',
      top: 'calc(50% - 0.75em)',
    },
  }
  return (
    <Grid container columnSpacing={1}>
      {label && (
        <Grid item xs={12}>
          {label}
        </Grid>
      )}
      <Grid item xs={12} mt={1}></Grid>
      <Grid item xs={4}>
        {/* <InputLabel
          sx={{ fontSize: '16px', padding: '0 4px', lineHeight: '1.6em' }}
          id="month-select-label"
        >
          Month
        </InputLabel>
        <Select
          id="month-select"
          value={datePartsMonth}
          onChange={handleMonthChange}
          MenuProps={{
            style: {
              maxHeight: 350,
            },
          }}
          sx={{
            padding: '0.5rem 0.75rem !important',
            '&>div.MuiSelect-select': {
              width: '100% !important',
              padding: '0 !important',
            },
            '&>svg': {
              fontSize: '1.5rem !important',
              display: 'inline-block',
            },
          }}
        >
          {selectData.datesMonth.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select> */}
        <TextField
          id="select-month"
          label="Month"
          value={datePartsMonth}
          onChange={handleMonthChange}
          select
          fullWidth
          sx={selectStyles}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              MenuListProps: {
                autoFocusItem: true,
              },
            },
          }}
        >
          {selectData.datesMonth.map((item) => (
            <MenuItem
              value={item.value}
              key={item.value}
              selected={item.value === datePartsMonth}
            >
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        {/* <InputLabel
          sx={{ fontSize: '16px', padding: '0 4px', lineHeight: '1.6em' }}
          id="day-select-label"
        >
          Day
        </InputLabel>
        <Select
          id="day-select"
          value={datePartsDay}
          onChange={handleDayChange}
          MenuProps={{
            style: {
              maxHeight: 350,
            },
          }}
          sx={{
            padding: '0.5rem 0.75rem !important',
            '&>div.MuiSelect-select': {
              width: '100% !important',
              padding: '0 !important',
            },
            '&>svg': {
              fontSize: '1.5rem !important',
              display: 'inline-block',
            },
          }}
        >
          {selectData.datesDay.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select> */}
        <TextField
          id="select-day"
          label="Day"
          value={datePartsDay}
          onChange={handleDayChange}
          select
          fullWidth
          sx={selectStyles}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              MenuListProps: {
                autoFocusItem: true,
              },
            },
          }}
        >
          {selectData.datesDay.map((item) => (
            <MenuItem
              value={item.value}
              key={item.value}
              selected={item.value === datePartsDay}
            >
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={4}>
        {/* <InputLabel
          sx={{ fontSize: '16px', padding: '0 4px', lineHeight: '1.6em' }}
          id="year-select-label"
        >
          Year
        </InputLabel>
        <Select
          id="year-select"
          value={datePartsYear}
          onChange={handleYearChange}
          MenuProps={{
            style: {
              maxHeight: 350,
            },
          }}
          sx={{
            padding: '0.5rem 0.75rem !important',
            '&>div.MuiSelect-select': {
              width: '100% !important',
              padding: '0 !important',
            },
            '&>svg': {
              fontSize: '1.5rem !important',
              display: 'inline-block',
            },
          }}
        >
          {selectData.datesYear.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select> */}
        <TextField
          id="select-year"
          label="Year"
          value={datePartsYear}
          onChange={handleYearChange}
          select
          fullWidth
          sx={selectStyles}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              MenuListProps: {
                autoFocusItem: true,
              },
            },
          }}
        >
          {selectData.datesYear.map((item) => (
            <MenuItem
              value={item.value}
              key={item.value}
              selected={item.value === datePartsYear}
            >
              {item.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  )
}
